import { render, staticRenderFns } from "./setting-billing-model.vue?vue&type=template&id=145b5490&"
import script from "./setting-billing-model.vue?vue&type=script&lang=js&"
export * from "./setting-billing-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports